if (!customElements.get('sticky-atc-bar')) {
  class StickyAtcBar extends HTMLElement {
    constructor() {
      super()
      this.closed = false
      this.handleScroll = this.updateVisibility.bind(this)
      this.handleResize = this.updateVisibility.bind(this)
    }

    connectedCallback() {
      this.bar = this.closest('.sticky-atc-bar')
      if (!this.bar) return

      this.select = this.querySelector('.atc-bar-product__select')
      this.formBtn = this.querySelector('.button-add-card')
      this.formInput = this.querySelector('input[name="id"]')
      this.price = this.querySelector('.price')
      this.image = this.querySelector('.atc-bar-product__img')
      this.closeBtn = this.querySelector('.sticky-close-button')
      this.aboutItem = document.querySelector('about-item')

      this.bindVariantControls()
      this.bindVisibility()
      this.updateVisibility()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleResize)
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.handleClose)
      if (this.aboutObserver) this.aboutObserver.disconnect()
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber()
      if (this.variantUnavailableUnsubscriber) this.variantUnavailableUnsubscriber()
    }

    bindVisibility() {
      // [X站UI-20260814 #13] PC 根据 About this item 进入视口显示，移动端始终显示
      window.addEventListener('scroll', this.handleScroll, { passive: true })
      window.addEventListener('resize', this.handleResize)

      this.handleClose = () => {
        this.closed = true
        this.bar.classList.remove('atc-visible')
      }
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.handleClose)

      if (this.aboutItem && typeof MutationObserver !== 'undefined') {
        this.aboutObserver = new MutationObserver(() => this.updateVisibility())
        this.aboutObserver.observe(this.aboutItem, { attributes: true, attributeFilter: ['class'] })
      }
    }

    bindVariantControls() {
      if (this.select) {
        this.select.addEventListener('change', (event) => {
          this.updateMasterId(event.target.value)
          this.updateVariantMedia(event.target.value)
          this.renderProductInfo()
        })
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.updateVariantState(event.data && event.data.variant)
        })
        this.variantUnavailableUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChangeUnavailable, () => {
          this.toggleAddButton(true, window.variantStrings?.soldOut || window.variantStrings?.unavailable)
        })
      }
    }

    updateVisibility() {
      if (!this.bar) return
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.bar.classList.add('atc-visible')
        return
      }
      if (this.closed || !this.aboutItem || this.aboutItem.classList.contains('hidden')) {
        this.bar.classList.remove('atc-visible')
        return
      }
      const aboutTop = this.aboutItem.getBoundingClientRect().top
      const visible = aboutTop <= window.innerHeight * 0.85
      // [埋点-20260827] PC 浮窗从隐藏变可见时上报曝光事件（标准页 / 专车页共用 _20260703）
      if (visible && !this.bar.classList.contains('atc-visible')) {
        // 专车模板 PC 端本 bar 被 display:none 隐藏（vehicle-sticky-atc 接管曝光），跳过上报但不影响显隐切换
        const barStyle = window.getComputedStyle(this.bar)
        if (barStyle.display !== 'none' && barStyle.visibility !== 'hidden') {
          const isVehicleTpl = this.bar.dataset.vehicleTpl === 'true'
          gaReportEvent('event', isVehicleTpl ? 'PremiumCarProductsPage' : 'StandardProductsPage', 'AddToCartPopupShow_20260703', {
            auto_id: window.fitmentAutoId,
            sku_id: window.productConfig && window.productConfig.productSku
          })
        }
      }
      this.bar.classList.toggle('atc-visible', visible)
    }

    updateMasterId(id) {
      this.currentVariant = id
      if (this.formInput) this.formInput.value = id
    }

    updateVariantState(variant) {
      if (!variant) return
      this.updateMasterId(variant.id)
      if (this.select) this.select.value = variant.id
      this.updateVariantMedia(variant.id)
      this.renderProductInfo()
    }

    updateVariantMedia(id) {
      if (!this.image || !this.select) return
      const option = Array.from(this.select.options).find((item) => item.value === String(id))
      if (option && option.dataset.media) this.image.src = option.dataset.media
    }

    renderProductInfo() {
      if (!this.currentVariant) return
      fetch(`${this.dataset.url}?variant=${this.currentVariant}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const addButtonUpdated = html.querySelector('.main-product .product-form__submit')
          const priceHtml = html.querySelector('.product__info-wrapper .price')
          this.toggleAddButton(
            !addButtonUpdated || addButtonUpdated.hasAttribute('disabled'),
            window.variantStrings?.soldOut
          )
          this.updatePrice(priceHtml)
        })
        .catch(() => {
          this.toggleAddButton(true, window.variantStrings?.soldOut)
        })
    }

    toggleAddButton(disable = true, text) {
      if (!this.formBtn) return
      const buttonText = this.formBtn.querySelector('span')
      this.formBtn.toggleAttribute('disabled', disable)
      if (buttonText && text) buttonText.textContent = text
      if (!disable && buttonText) buttonText.textContent = window.variantStrings?.addToCart || buttonText.textContent
    }

    updatePrice(price) {
      if (!this.price || !price) return
      const duplicatePrice = price.cloneNode(true)
      this.price.replaceWith(duplicatePrice)
      this.price = duplicatePrice
    }
  }

  customElements.define('sticky-atc-bar', StickyAtcBar)
}
